<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;" v-if="newWorker == undefined">
            <div class="col s1">
            </div>
            <div class="col s3 input-field">
                <p v-on:click="setWorkersOrder('full_name')" class="cursor-pointer">
                    {{$t('worker.name_surname')}}
                    <i class="material-icons dp6" v-if="workerorderby == 'full_name' && workerorder == 'desc'">arrow_drop_down</i>
                    <i class="material-icons dp6" v-if="workerorderby == 'full_name' && workerorder == 'asc'">arrow_drop_up</i>
                </p>
                <input v-model="workersearch" />
            </div>
            <div class="col s3  input-field" style="text-transform: uppercase;">
                <p v-on:click="setWorkersOrder('position')" class="cursor-pointer">
                    {{$t('worker.position')}}
                    <i class="material-icons dp6" v-if="workerorderby == 'position' && workerorder == 'desc'">arrow_drop_down</i>
                    <i class="material-icons dp6" v-if="workerorderby == 'position' && workerorder == 'asc'">arrow_drop_up</i>
                </p>
                <input v-model="workerpositionsearch" />
            </div>
            <div class="col s3  input-field" style="text-transform: uppercase;">
                <p v-on:click="setWorkersOrder('active')" class="cursor-pointer">
                    {{$t('worker.status')}}
                    <i class="material-icons dp6" v-if="workerorderby == 'active' && workerorder == 'desc'">arrow_drop_down</i>
                    <i class="material-icons dp6" v-if="workerorderby == 'active' && workerorder == 'asc'">arrow_drop_up</i>
                </p>
                <selector v-model="selectedworkerstatuses" :items="workerstatuses" identifier="workerstatus"></selector>
            </div>
            <div class="col s2 input-field" style="text-align: end;" v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
                <a class="waves-effect waves-light btn solidgreen" v-on:click="addWorker()" style="margin-top: 20px;">{{$t('worker.add_worker')}}</a>
            </div>
        </div>
        <ul class="collapsible">
            <li v-if="newWorker != undefined">
                <worker
                    v-bind:worker="newWorker"
                    v-on:addWorker="addedWorker"
                    v-on:cancelAdding="cancelAdd"
                   
                    ref="newWorker"/>
            </li>
            <li v-for="worker in listWorkers">
                <div class="workerline" v-on:click="toggleWorker(worker.id)" v-bind:class="{'reded': (workerspopened.indexOf(worker.id) > -1) }">
                    <div class="row" style="width: 100%;">
                        <div class="col s1">
                            <template v-if="worker.photo != null && worker.photo != undefined">
                                <v-lazy-image
                                    v-bind:src="worker.photo"
                                    src-placeholder="/nofoto.png"
                                    width="64"
                                    v-on:error="imageLoadError(worker)"
                                />
                            </template>
                            <template v-else>
                                <img src="/nofoto.png" style="width: 64px;"/>
                            </template>
                        </div>
                        <div class="col s3"> {{worker.name}} {{worker.surname}}</div>
                        <div class="col s3"> {{worker.position}}</div>
                        <div class="col s3"> {{worker.active ? $t('worker.active') : $t('worker.inactive')}}</div>
                        <div class="col s2" v-if="worker.isadmin">{{$t('worker.admin')}}</div>
                    </div>
                </div>
                <transition name="fade">
                <worker
                    v-bind:worker="worker"
                    v-if="workerspopened.indexOf(worker.id) > -1"
                    v-on:updateWorker="workerUpdate"
                    v-on:workerRemove="workerRemove"
                    ref="workers"/>
                </transition>
            </li>
            <li>
                <div class="row" style="width: 100%;" v-if="workers_loaded == false">
                    <div class="col s12">
                        <div class="container" style="width: 3%; margin: auto;">
                            <div class="preloader-wrapper active">
                                <div class="spinner-layer spinner-red-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="row" style="width: 100%;" v-if="workers_loaded == true && listWorkers.length == 0">
                    {{$t('worker.no_workers')}}
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';

export default {
    props: { role: String, extended_privileges: Boolean },
    data: function() {
        return {
            workerorder: 'desc',
            workerorderby: 'full_name',
            workersearch: "",
            workerpositionsearch: "",
            workers: [],
            workerspopened: [],
            workers_loaded: false,
            loaded: false,
            selectedworkerstatuses: [true],
            workerstatuses: [{ "name": this.$t('worker.active'), "value": true }, { "name": this.$t('worker.inactive'), "value": false }],
            newWorker: undefined
        }
    },
    created() {
        this.fetch_pests();
    },
    mounted() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, { accordion: true });
    },
    methods: {
        fetch_pests: function() {
            var that = this;
            axios.get('/workers.json').then(response => {
                this.workers = response.data;
                for (var i = this.workers.length - 1; i >= 0; i--) {
                    this.workers[i].edit = false;
                    this.workers[i].full_name = this.workers[i].name + " " + this.workers[i].surname
                }
                this.workers_loaded = true;
            });
        },
        anyEdited: function(){
            if(_.isUndefined(this.$refs.workers) == false){
                for (var i = this.$refs.workers.length - 1; i >= 0; i--) {
                    if(this.$refs.workers[i].editedWorker.edit){
                        return true;
                    }
                }
            }
            if(_.isUndefined(this.$refs.newWorker) == false){
                if(this.$refs.newWorker.editedWorker.edit){
                    return true;
                }
            }
            return false;
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        toggleWorker(worker_id){
            if(this.workerspopened.indexOf(worker_id) > -1){
                this.workerspopened = [];
            }else{
                this.workerspopened = [worker_id];
            }
        },
        addedWorker(worker) {
            this.workers.push(worker);
            this.newWorker = undefined;
        },
        cancelAdd() {
            this.newWorker = undefined;
        },
        workerUpdate(worker){
            var oldworker = _.find(this.workers, {id: worker.id});
            _.assign(oldworker, worker);
             this.$forceUpdate();
        },
        addWorker() {
            this.newWorker = { edit: true, editable: true, tag_list: [], name: "", invitation_email: "" }
            this.$forceUpdate();
        },
        workerRemove(worker){
            this.workers.splice(this.workers.indexOf(worker), 1);
        },
        setWorkersOrder: function(order) {
            if (this.workerorderby == order) {
                if (this.workerorder == 'desc') {
                    this.workerorder = 'asc'
                } else if (this.workerorder == 'asc') {
                    this.workerorder = 'desc'
                }

            } else {
                this.workerorderby = order;
            }
        },
        imageLoadError: function(worker){
            worker.photo = null;
        }
    },
    computed: {
        listWorkers() {
            var that = this;
            return _.filter(
                _.orderBy(this.workers, this.workerorderby, this.workerorder),
                function(item) {
                    var full = item.name.toUpperCase() + " " + item.surname.toUpperCase()
                    return (full.indexOf(that.workersearch.toUpperCase()) >= 0) && (item.position.toUpperCase().indexOf(that.workerpositionsearch.toUpperCase()) >= 0) && (_.includes(that.selectedworkerstatuses, item.active) || that.selectedworkerstatuses.length == 0)
                }
            );
        },

    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
p.cursor-pointer {
  font-size: 1em;
  margin: 0;
}
.settingsform {
    padding-top: 15px;
}

.login_button {
    color: red;
}

.selectorignored select {
    display: block;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.input-field {
    margin: 0px !important;
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.collapsible-body .collapsible-header {
    background-color: #FFF;
    text-transform: initial;
}

.collapsible-body .collapsible-header .row {
    margin-bottom: 0px;
}

.collapsible-body .collapsible-body.formul {
    background-color: #FFF;
    margin-top: 5px;
    border-bottom-style: solid;
    border-bottom-width: 5px;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}
.workerline{
    display: flex;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    line-height: 1.5;
    padding: 1rem;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.reded {
    border-color: rgb(194, 32, 38);
    border: 4px solid rgb(194, 32, 38);
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
}

.collapsible-body {
    padding: 1em;
    padding-right: 0em;
    padding-left: 1em;
}

.collapsible li i {
    position: absolute;
    right: 15px;
}

.collapsible li.active i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
    transform: rotate(180deg);
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.btn-small {
    color: black;
    border-radius: 8px;
}
</style>